import { useTranslation } from 'react-i18next'

import { CalendarBlankIcon, ClockIcon, CoinsIcon, HandCoinsIcon, ReceiptIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import Statistic from '@/common/components/Statistic/Statistic'
import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'

import * as Styles from './styles'

const BillingAnalytics = ({
  pendingInvoices,
  pendingInvoicesAmount,
  nextInvoiceDate,
  nextInvoiceFeeAmount,
  nextInvoiceAmount,
  nextInvoiceInstantAmount,
  currency,
  onClickInStat,
}) => {
  const { t, i18n } = useTranslation()

  return (
    <Styles.MainContainer>
      <StatisticGroup>
        <Statistic
          size="small"
          isOutlined={false}
          Icon={ReceiptIcon}
          label={t('Facturas pendientes')}
          value={<AnimatedNumber target={pendingInvoices} format="decimal" />}
          showStatusIcon={Number(pendingInvoices) > 0}
          onClick={() => onClickInStat('pendingInvoices')}
        />
        <Statistic
          size="small"
          isOutlined={false}
          Icon={ClockIcon}
          label={t('Cantidad pendiente')}
          value={<AnimatedNumber target={pendingInvoicesAmount} format="currency" currency={currency} />}
          showStatusIcon={Number(pendingInvoicesAmount) > 0}
        />
      </StatisticGroup>
      <StatisticGroup>
        <Statistic
          size="small"
          isOutlined={false}
          Icon={CalendarBlankIcon}
          label={t('Próxima factura')}
          value={
            nextInvoiceDate &&
            new Intl.DateTimeFormat(i18n.language, { month: 'long', day: 'numeric', year: 'numeric' }).format(
              new Date(nextInvoiceDate)
            )
          }
        />
        <Statistic
          size="small"
          isOutlined={false}
          Icon={HandCoinsIcon}
          label={t('Comisiones')}
          value={<AnimatedNumber target={nextInvoiceFeeAmount} format="currency" currency={currency} />}
        />
        <Statistic
          size="small"
          isOutlined={false}
          Icon={CoinsIcon}
          label={t('Balance acumulado')}
          value={<AnimatedNumber target={nextInvoiceAmount} format="currency" currency={currency} />}
        />
        <Statistic
          size="small"
          isOutlined={false}
          Icon={CoinsIcon}
          label={t('Importe adelantado por Reveni')}
          value={<AnimatedNumber target={nextInvoiceInstantAmount} format="currency" currency={currency} />}
        />
      </StatisticGroup>
    </Styles.MainContainer>
  )
}

export default BillingAnalytics
